import Stack from 'atoms/Layout/Stack/Stack';
import styled from 'styled-components';

export const WistiaPlayerContainer = styled(Stack)`
  display: block;
  width: 100%;
`;
